import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHoseConnection = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20.0 20.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 20.0 0.0 L 10.0 0.0 L 10.0 20.0 L 20.0 20.0 M 0.0 10.0 L 10.0 10.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgHoseConnection;
